import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  initials: 'MG',
  quote: 'Mis clases de Química por fin enganchan',
  name: 'Martín G.',
  location: 'GBA | secundaria'
}];
export function ShortTestimonials() {
  return;
}